var sb = require('@sb/util')
var config = require('@sb/config')
import api from './api.js'

var client = require('@subiz/wsclient/src/client.js')
client.env.WebSocket = window.WebSocket
var WS = client.WS

var Ws = {
	loadgate: new sb.Gate(),
	connId: '', // connection id
	pubsub: new sb.Pubsub(),

	subscribedEvents: {}, // connection id => events list

	un (subid) {
		return this.pubsub.un(subid)
	},

	onMessage (cb) {
		return this.pubsub.on('message', cb)
	},

	onReconnect (cb) {
		return this.pubsub.on('reconnect', cb)
	},

	getConnectionId () {
		return this.connId
	},

	isSubscribed (connid, events) {
		var unsub = sb.find(events, e => this.subscribedEvents[connid][e] === undefined)
		return !!unsub
	},

	async subscribe (events) {
		await this.loadgate.entry()
		var currentConn = this.connId
		if (!currentConn) return 'not_connect_ws'
		var subedEvs = this.subscribedEvents[this.connId] || {}
		let newEvs = sb.filter(events, ev => subedEvs[ev] === undefined)
		if (sb.size(newEvs) === 0) return

		await api.subscribeWsEvents(currentConn, newEvs)
		sb.each(newEvs, ev => {
			subedEvs[ev] = true
		})
		this.subscribedEvents[currentConn] = newEvs
	},

	constructor () {
		const WS_URL = config.WsURL
		const NUMBER_OF_SERVER_WS = 1
		this.ws = new WS({
			pickUrl: done => {
				var id = Math.round(Math.random() * (NUMBER_OF_SERVER_WS - 1))
				done(WS_URL.replace('*ID*', id))
			},
		})

		this.ws.onconnected = (_, id) => {
			if (id === this.connId) return

			// only fire when connection is changed
			// if (this.connId) this.pubsub.publish('reconnect', id)
			this.connId = id
			console.log('ws.onconnected => connection_id', id)
			this.loadgate.open()
		}

		this.ws.onmessage = (_, message, offset) => {
			// console.log(new Date().toISOString(), 'ws => ', message.type, message.data)
			this.pubsub.publish('message', message)
			if (message && offset) this.ws.commit(offset)
		}
	},

	reset () {
		this.loadgate.close()
		this.subscribedEvents = {}
		this.connId = ''
		this.pubsub = new sb.Pubsub()
		this.ws && this.ws.destroy()
		this.constructor()
	},
}
Ws.constructor()

export default Ws
